import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL || "/api" });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("crm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  (res) => res,
  (err) => {
    const issueRef = err.response?.data?.issue_ref;
    if (issueRef) {
      localStorage.setItem("ebek_last_error_ref", issueRef);
      err.response.data.error = `Something went wrong. Reference: ${issueRef}`;
    }
    const isLogin = err.config?.url?.includes("/auth/login");
    if (err.response?.status === 401 && !isLogin) {
      console.error("[CRM 401] Session expired on:", err.config?.url, "— redirecting to login");
      const keepChat  = localStorage.getItem("company_chat_keep_signed_in") === "1";
      const chatToken = localStorage.getItem("company_chat_token");
      const hrmsToken = localStorage.getItem("hrms_token"); // preserve for app switching
      const offlineVisits = localStorage.getItem("ebek_offline_visits_v1");
      localStorage.clear();
      if (keepChat) {
        localStorage.setItem("company_chat_keep_signed_in", "1");
        if (chatToken) localStorage.setItem("company_chat_token", chatToken);
      }
      if (hrmsToken) localStorage.setItem("hrms_token", hrmsToken);
      if (offlineVisits) localStorage.setItem("ebek_offline_visits_v1", offlineVisits);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default API;
